/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-09 11:28:14
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-09 11:33:32
 * @name: 设置文件
 * @Description: 设置文件
 * @FilePath: \backstage\src\settings.js
 * @Author: DESKTOP-1QU67QM
 */
module.exports = {
  title: '售前售后管理系统',
}
